import styled from "styled-components";

export const SPricingCard = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
